<template>
  <LoginLayout>
    <v-container fluid class="fill-height" style="background-color: white;">
      <v-row justify="center" align="center" style="height: 100vh;">
        <v-col cols="12" md="6" class="text-center">
          <h2>Bienvenido! 👋🏻</h2>
          <p class="sub-title">Inicia sesión en tu cuenta.</p>
          <v-card class="elevation-0 mx-auto pt-10" max-width="400">
            <v-card-text>
              <div class="d-flex justify-center mb-6">
                <v-img lazy-src="/img/logo_planti_08.png" max-height="150" max-width="250"
                  src="/img/Logotipo Final Planti-04.png"></v-img>
              </div>

              <v-form>
                <v-text-field color="primary" prepend-icon="person" name="login" label="Login" type="text"
                  v-model="username" outlined dense></v-text-field>
                <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password"
                  v-model="password" v-on:keyup.enter="login" outlined dense></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions class="justify-center">
              <v-btn color="primary" @click="login" :loading="load">
                Iniciar Sesión
              </v-btn>
            </v-card-actions>

            <v-card-actions class="justify-center pt-5 pb-8">
              <router-link to="/remember" color="primary" class="remember">
                ¿Olvidó Contraseña?
              </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-snackbar v-model="snackbar" :vertical="vertical">
        <span v-html="text"></span>
        <template v-slot:action="{ attrs }">
          <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </LoginLayout>
</template>

<script>
import LoginLayout from "@/layout/LoginLayout.vue";
import LoginJS from "@/http/Auth";
import Storage from "@/store/modules/Storage";

export default {
  components: {
    LoginLayout,
  },
  data() {
    return {
      load: false,
      username: "",
      password: "",
      snackbar: false,
      text: "",
      vertical: true,
    };
  },
  methods: {
    login() {
      this.load = true;
      this.text = "";
      LoginJS.login(this.username, this.password).then((response) => {
        this.load = false;
        if (response.status === 200) {
          Storage.setUser(response.data);
          this.$store.commit("SET_USER_ID", 10000);
          this.$router.push("dashboard");
        } else {
          this.snackbar = true;
          this.text = response.data.error;
        }
      });
    },
  },
};
</script>

<style scoped>
.remember {
  font-family: Roboto;
  font-size: 1.1rem;
  font-weight: bolder;
  line-height: 1;
  letter-spacing: 0.1px;
  text-align: left;
  color: var(--v-primary-base) !important;
}

h2 {
  font-family: Roboto;
  font-size: 2.5rem !important;
}

.sub-title {
  font-family: Roboto;
  font-size: 1.1rem !important;
}
</style>